import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles, FormControl, TextField, CircularProgress } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
import { DropDownIcon } from '../Images/Icons';
import { useField } from 'formik';
const styles = makeStyles({
    rootFormControl: {
        width: '100%'
    },
    label: {
        paddingBottom: '8px',
        color: '#767676'
    },
    autoCompleteRoot: {
        width: '100%',
        marginLeft: '0px !important'
    },
    textFieldRoot: {
        '& label': {
            display: 'none'
        }
    },
    inputRoot: ({ disabled }) => ({
        paddingRight: '10px !important',
        border: 'solid 1px rgb(187,187,187)',
        backgroundColor: disabled ? '#f0f0f0' : '#ffffff',
        opacity: disabled ? '0.5' : 1,
        // borderRadius: (props) => (props.isMobile ? '4px ' : '9px'),
        fontSize: '16px',
        '&:focus-within': {
            border: 'solid 1px #1b90fa'
        }
    }),
    icon: {
        position: 'absolute',
        pointerEvents: 'none'
    },
    input: {
        padding: '6px 4px 7px !important',
        lineHeight: '1.67em',
        height: '1.67em',
        '&:disabled': {
            cursor: 'not-allowed',
            marginRight: '-10px'
        }
    },
    errorContainer: {
        padding: '3px 0px',
        fontSize: '0.9em',
        color: 'red',
        minHeight: '26px'
    },
    tag: {
        borderRadius: '9px',
        backgroundColor: '#d4e4fc',
        '& svg': {
            width: '15px',
            height: '15px',
            margin: '0px 0px 0px 8px !important',
            color: 'black'
        }
    },
    option: {
        fontFamily: 'mainFont',
        fontSize: '14px',
        direction: (props) => (props.optionsDirection === 'ltr' ? 'ltr' : 'rtl'),
        textAlign: (props) =>
            props.optionsDirection === 'ltr'
                ? 'left'
                : props.optionsDirection === 'ltr' && props.options.length === 0
                ? 'center'
                : 'right'
    },
    noOptions: {
        fontFamily: 'mainFont'
    },
    popupIndicator: {
        marginLeft: '5px',
        padding: '5px !important'
    },
    endAdornment: (props) => ({
        left: props.rtl ? '10px' : 'auto',
        right: props.rtl ? 'auto' : '10px',
        display: props.disableEndAdornment && 'none'
    })
    // indeterminate: {
    //     position: 'absolute',
    //     left: '40px'
    // }
});
function ClinicAutocomplete(props) {
    const {
        hasValidation = true,
        isValidate = true,
        disabled = false,
        disableEndAdornment = false
    } = props;
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ ...props, rtl: lang === 'fa', disabled, disableEndAdornment });
    const [value, setValue] = useState([]);
    const [field, meta] = useField(props);

    useEffect(() => {
        const array = props.options.filter((el) => props.value.includes(el.id));
        setValue(array);
    }, [props.value, props.options]);

    const handleChange = (newValue) => {
        setValue(newValue);
        //an array would be returned
        const array = newValue.map((i) => i.id);
        props.setValue(array);
    };

    return (
        <FormControl
            disabled={props.disabledInfo === '' ? true : false}
            classes={{ root: classes.rootFormControl }}
        >
            <label className={classes.label} htmlFor={props.id || props.name}>
                {props.label}
            </label>
            <Autocomplete
                id="tags-standard"
                classes={{
                    clearIndicatorDirty: classes.clearIndicator,
                    popupIndicator: classes.popupIndicator,
                    endAdornment: classes.endAdornment,
                    root: classes.autoCompleteRoot,
                    inputRoot: props.customClasses?.inputRoot || classes.inputRoot,
                    input: classes.input,
                    option: classes.option,
                    tag: props.customClasses?.tag || classes.tag,
                    noOptions: classes.noOptions
                }}
                popupIcon={
                    props.customIcon ? (
                        props.customIcon
                    ) : props.customIcon === null ? null : (
                        <DropDownIcon className={classes.icon} height="24" width="24" fill="#bbb" />
                    )
                }
                loading={props.loading}
                noOptionsText={props.noOptionsText || messages.noLocationFound}
                multiple
                options={props.options}
                getOptionLabel={(option) => option.name}
                value={value}
                ChipProps={props.chipProps}
                disabled={disabled}
                onChange={(_, newValue) => {
                    if (!isValidate) {
                        return;
                    } else {
                        handleChange(newValue);
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        classes={{
                            root: classes.textFieldRoot
                        }}
                        {...params}
                        {...props}
                        {...field}
                        label={props.label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {props.loading ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        params.InputProps.endAdornment
                                    )}
                                </>
                            )
                        }}
                    />
                )}
            />
            <div className={hasValidation && classes.errorContainer}>
                {meta.touched && meta.error ? <span>{meta.error}</span> : null}
            </div>
        </FormControl>
    );
}
ClinicAutocomplete.propTypes = {
    label: PropTypes.string,
    id: PropTypes.any,
    name: PropTypes.string,
    options: PropTypes.array,
    optionsLabel: PropTypes.string,
    value: PropTypes.any,
    setValue: PropTypes.func,
    disabledInfo: PropTypes.any,
    loading: PropTypes.bool,
    optionsDirection: PropTypes.string,
    hasValidation: PropTypes.bool,
    customClasses: PropTypes.object,
    customIcon: PropTypes.any,
    chipProps: PropTypes.any,
    isValidate: PropTypes.bool,
    disabled: PropTypes.bool,
    disableEndAdornment: PropTypes.bool,
    noOptionsText: PropTypes.string
};

export default ClinicAutocomplete;
